/* tslint:disable */
/* eslint-disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';
import { Observable } from 'rxjs';
import { map, filter } from 'rxjs/operators';


@Injectable({
  providedIn: 'root',
})
export class FileUploadControllerService extends BaseService {
  constructor(
    config: ApiConfiguration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * Path part for operation fileUploadControllerFileUpload
   */
  static readonly FileUploadControllerFileUploadPath = '/files';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `fileUpload()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  fileUpload$Response(params: {
    destination?: string;
    taillemax?: string;

    /**
     * Request body for multipart/form-data based file upload
     */
    body: { 'file'?: Blob }
  }): Observable<StrictHttpResponse<{  }>> {

    const rb = new RequestBuilder(this.rootUrl, FileUploadControllerService.FileUploadControllerFileUploadPath, 'post');
    if (params) {
      rb.query('destination', params.destination, {});
      rb.query('taillemax', params.taillemax, {});
      rb.body(params.body, 'multipart/form-data');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<{  }>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `fileUpload$Response()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  fileUpload(params: {
    destination?: string;
    taillemax?: string;

    /**
     * Request body for multipart/form-data based file upload
     */
    body: { 'file'?: Blob }
  }): Observable<{  }> {

    return this.fileUpload$Response(params).pipe(
      map((r: StrictHttpResponse<{  }>) => r.body as {  })
    );
  }

  /**
   * Path part for operation fileUploadControllerFileDelete
   */
  static readonly FileUploadControllerFileDeletePath = '/files';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `fileDelete()` instead.
   *
   * This method doesn't expect any request body.
   */
  fileDelete$Response(params?: {
    filename?: string;
  }): Observable<StrictHttpResponse<{  }>> {

    const rb = new RequestBuilder(this.rootUrl, FileUploadControllerService.FileUploadControllerFileDeletePath, 'delete');
    if (params) {
      rb.query('filename', params.filename, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<{  }>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `fileDelete$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  fileDelete(params?: {
    filename?: string;
  }): Observable<{  }> {

    return this.fileDelete$Response(params).pipe(
      map((r: StrictHttpResponse<{  }>) => r.body as {  })
    );
  }

}
